import { AppStatus } from '@/redux'

import { missingFrom } from '@/features/Auth/machine/completion'
import { nextCompletionStep } from '@/features/Auth/session/completionRoutes'
import { awaitProfileComplete } from '@/features/Auth/session/awaitProfileComplete'
import { awaitSignedIn } from '@/features/Auth/session/awaitSignedIn'
import { ensureEmailVerified } from '@/features/Auth/session/ensureEmailVerified'
import { maybeOpenRegistrationWall } from '@/features/Auth/session/registrationWall'
import { isLoggedIn } from '@/features/Auth/session/utils'
import { QueryKeys } from '@/services/api/session/queryKeys'

export async function ensureProfileDetails() {
  const profile = QueryKeys.me.getData()
  const missing = missingFrom(profile)

  const step = nextCompletionStep(missing)

  if (step) {
    AppStatus.setModal(step as any)

    if (!(await awaitProfileComplete())) {
      throw new Error('Profile not complete', { cause: 'ensureProfileDetails' })
    }
  }

  await ensureEmailVerified(profile)
}

export async function ensureLoggedIn() {
  if (isLoggedIn()) return true

  maybeOpenRegistrationWall()

  if (!(await awaitSignedIn())) {
    throw new Error('User is not logged in', { cause: 'ensureLoggedIn' })
  }

  return true
}

export async function ensureProfileCompletion(checkProfileDetails?: boolean): Promise<void> {
  await ensureLoggedIn()

  if (checkProfileDetails) {
    await ensureProfileDetails()
  }
}
